import React from "react"
import GSAPComponent from "../../components/GSAPComponent"

export default class extends GSAPComponent {
  animate() {
    /* eslint-disable */
    const tl = new TimelineMax({ delay: 0.2 })
    const flower = this.svg.querySelector("#flower")
    const topLeaf = this.svg.querySelector("#top-leaf")
    const leftLeaf = this.svg.querySelector("#left-leaf")
    const rightLeaf = this.svg.querySelector("#right-leaf")
    const sign = this.svg.querySelector("#sign")

    tl.fromTo(topLeaf, 1, { y: 0 }, { y: -1, ease: Power3.easeOut }, 0)
    tl.fromTo(
      leftLeaf,
      1,
      { x: 0, y: 0 },
      { x: -1, y: 1, ease: Power3.easeOut },
      0
    )
    tl.fromTo(
      rightLeaf,
      1,
      { x: 0, y: 0 },
      { x: 1, y: 1, ease: Power3.easeOut },
      0
    )
    tl.from(flower, 1, { opacity: 0, ease: Power3.easeOut }, 0)
    tl.from(
      flower,
      1,
      { scale: 1.4, transformOrigin: "center", ease: Power3.easeInOut },
      1
    )
    tl.from(topLeaf, 1, { y: -1, ease: Power3.easeInOut }, 1)
    tl.from(leftLeaf, 1, { x: -1, y: 1, ease: Power3.easeInOut }, 1)
    tl.from(rightLeaf, 1, { x: 1, y: 1, ease: Power3.easeInOut }, 1)
    tl.to(flower, 1, { rotation: -120, ease: Power3.easeInOut }, 1)
    tl.to(flower, 0.5, { rotation: -240, ease: Power3.easeOut }, 2)
    tl.to(flower, 0.5, { x: -36, ease: Power3.easeOut }, 2)
    tl.to(sign, 0.5, { opacity: 1, ease: Power3.easeOut }, 2.1)

    return tl
    /* eslint-enable */
  }

  render() {
    return (
      <svg ref={ref => (this.svg = ref)} viewBox="0 0 93.1 36.9" width={350}>
        <path
          id="sign"
          d="M24.7 14.2h2.4c2.7 0 4.1 1.5 4.1 3.7s-1.6 3.8-4.3 3.8h-2.2v-7.5zm2.3 6.4c1.4.2 2.6-.8 2.8-2.2v-.5c.1-1.4-.9-2.6-2.2-2.7h-1.5v5.3l.9.1zm4.9-6c0-.4.4-.8.8-.8.5 0 .8.3.8.8s-.4.8-.8.8-.8-.3-.8-.8m.1 1.6h1.4v5.4H32v-5.4zm1.9 6.6c0-.6.4-1.1 1-1.3-.2-.1-.4-.4-.4-.7 0-.4.3-.8.7-1-.6-.4-.9-1-.9-1.7 0-1.1.9-2 2-2h.2c.4 0 .7.1 1.1.2h.1c.3-.3.8-.5 1.3-.5h.4l-.3 1h-.4c-.1 0-.3 0-.4.1.3.3.5.8.5 1.3 0 1.1-.9 2-2 2h-.3c-.2 0-.4 0-.7-.1-.1.1-.1.3-.1.4 0 1 3.6.1 3.6 2.1 0 1-1 1.8-2.9 1.8-1.6 0-2.5-.6-2.5-1.6m4.1 0c0-.8-1.7-.6-2.4-.9-.2.2-.4.4-.4.7 0 .5.6.9 1.5.9s1.3-.3 1.3-.7m-.5-4.6c0-.6-.4-1-1-1-.5 0-.9.4-.9.9v.1c0 .5.4 1 .9 1h.1c.5 0 1-.3 1-.8-.1 0-.1-.1-.1-.2m2.5-2h1.2l.1.6c.5-.4 1.2-.7 1.9-.7.9 0 1.8.4 1.8 2v3.6h-1.4v-3.2c0-.7-.1-1.2-.8-1.2-.5 0-1 .2-1.3.6v3.8H40v-5.5zm5.7-1.6c.1-.5.5-.8.9-.8s.7.4.8.8c0 .5-.4.8-.8.8-.5 0-.9-.3-.9-.8m.1 1.6h1.4v5.4h-1.4v-5.4zm3.3 4.2v-3h-1v-1.1h1V15l1.4-.4v1.6h1.7l-.3 1.1h-1.3V20c0 .5.2.7.5.7s.6-.1.8-.3l.4.9c-.5.3-1 .4-1.6.4-.8.1-1.5-.5-1.5-1.2-.1 0-.1 0-.1-.1m3.5 2.7c.3.1.5.2.8.2.6 0 1.1-.4 1.5-1.7l-2.4-5.4h1.4l1.7 3.9 1.3-3.9h1.4l-2.1 5.6c-.8 2.3-1.8 2.6-2.7 2.6-.4 0-.8 0-1.2-.2l.3-1.1zm8.4-8.9h1.4v3.1H66v-3.1h1.4v7.6H66v-3.3h-3.7v3.3H61v-7.6zm7.3 4.8c0-1.6.9-2.9 2.4-2.9s2.4 1.1 2.4 2.9v.3h-3.5c0 .8.6 1.4 1.4 1.4h.1c.5 0 1-.1 1.4-.4l.4 1c-.6.3-1.2.5-1.9.5-1.4.1-2.7-1-2.8-2.4.1-.1.1-.2.1-.4m3.4-.6c0-.6-.3-1.2-1-1.2-.6 0-1.1.5-1.1 1.2v.1h2.1zm5.4 2.8c-.4.4-1 .6-1.6.6-.9.1-1.7-.6-1.8-1.6v-.1c0-.6.3-1.2.9-1.5.4-.2.9-.3 1.4-.4h.9V18c0-.6-.4-.9-1-.9-.5 0-1 .1-1.4.4l-.5-.8c.6-.4 1.4-.5 2.1-.5 1.5 0 2.2.7 2.2 2v2.2c0 .5 0 .9.1 1.4h-1.1l-.2-.6zm-.9-2c-.3 0-.5.1-.8.2-.2.1-.4.4-.3.6 0 .4.3.7.7.7h.1c.4 0 .8-.2 1.1-.4v-1.1h-.8zm3.1-5.6h1.4v6.5c0 .4.2.5.4.5.1 0 .2 0 .3-.1l.3 1c-.3.1-.7.2-1 .2-.6.1-1.3-.3-1.4-1v-7.1zm3.2 6.8v-3h-1v-1.1h1V15l1.4-.4v1.6h1.6l-.3 1.1h-1.3V20c0 .5.2.7.5.7s.6-.1.8-.3l.4.9c-.5.3-1 .4-1.6.4-.8.1-1.5-.5-1.5-1.2v-.1m3.7-6.8h1.4v3.3c.5-.4 1.1-.7 1.8-.7.9 0 1.7.4 1.7 2v3.6h-1.4v-3.2c0-.7-.1-1.2-.8-1.2-.5 0-1 .2-1.3.6v3.8h-1.4v-8.2zM92 21v.8h-.1V21h-.3v-.1h.6v.1H92zm1.1.7v-.6l-.2.4h-.1l-.2-.4v.6h-.1v-.9h.1l.3.5.2-.5h.1l-.1.9z"
          opacity="0"
          fill="#fff"
        />
        <g id="flower" fill="#fff">
          <path
            id="left-leaf"
            d="M46.1 20.5c-.1-.5-.3-1-.6-1.4-.2-.4-.5-.8-.9-1.2-1.8-1.9-4.7-2.3-7-1-.5.3-.9.6-1.2 1-.3.3-.3.8 0 1.1.2.2.6.5.6.5.2.1.4.3.6.4.9.5 1.9.8 2.9.8 1.3 0 2.5-.4 3.5-1.2-.1-.2-.3-.4-.5-.5-.1-.1-.2-.2-.3-.2-.1-.1-.3-.2-.4-.3-.2.1-.3.2-.5.3-.6.3-1.2.4-1.9.4-.8 0-1.5-.2-2.1-.6l-.2-.2c-.2.1-.4.3-.6.5.3-.2.5-.5.8-.7 2-1.2 4.6-.5 5.8 1.5.2.3.3.6.4 1 .5 1.9-.3 3.9-2 4.8-.1.1-.2.1-.3.2v-.2c0-1.6.9-3.1 2.4-3.8 0-.3-.1-.6-.1-.8-.1-.2-.1-.5-.3-.7-2.1.9-3.5 3-3.5 5.4l.1-.1v.7h.1s.1.5.1.8c.1.4.5.6.9.5 3.1-.7 5-3.9 4.2-7z"
          />
          <path
            id="top-leaf"
            d="M52.2 9.8c-.1-.3-.4-.6-.7-.6h-.2c-.3.1-.5.2-.8.3v.1c-.2.1-.5.2-.7.3-2 1.2-3.1 3.4-2.9 5.7h-.8c.3-2.3-.9-4.5-2.9-5.7-.2-.1-.5-.2-.7-.3-.2-.1-.5-.2-.8-.3-.4-.1-.8.1-.9.5-.1.5-.2 1-.2 1.5 0 2.6 1.8 5 4.3 5.6 1 .3 2 .3 2.9 0 2.6-.7 4.3-3 4.4-5.6.2-.4.1-1 0-1.5zm-9.7.2c0 .1-.1.2-.1.2 0 .2-.1.4-.1.6 0-.2 0-.4.1-.6.1 0 .1-.1.1-.2zm-.2 1.4v-.3l.3.1c1.4.8 2.2 2.4 2.1 4-1.4-.7-2.4-2.2-2.4-3.8zm8.4-1.2c.1.3.1.5.1.8 0-.2 0-.5-.1-.8V10v.2zm-2.3 5c-.1-1.6.7-3.1 2.1-4l.3-.1v.3c.1 1.6-.9 3.1-2.4 3.8z"
          />
          <path
            id="right-leaf"
            d="M56.8 17.9c-.4-.4-.8-.7-1.2-1-2.3-1.3-5.2-.9-7 1v.1c-.3.4-.7.7-.9 1.2-.2.4-.4.9-.6 1.4-.7 2.5.4 5.3 2.7 6.6.5.3.9.5 1.4.6h.2c.3 0 .6-.2.7-.6.1-.2.2-.7.2-.8v-.8c0-2.3-1.4-4.4-3.5-5.3.1-.1.1-.2.1-.3.1-.2.2-.3.3-.5l.3-.3-.4.4c1 .8 2.2 1.2 3.5 1.2 1 0 2-.3 2.9-.8.2-.1.4-.3.6-.4.1-.1.3-.3.5-.4.5-.6.5-1 .2-1.3zm-5.9 7.6v.3l-.3-.1c-1.4-.8-2.2-2.4-2.1-4 0-.3.1-.6.1-.8v-.1c0-.1.1-.3.2-.4-.1.1-.1.3-.2.4v.1c-.1.3-.1.5-.1.8 1.4.7 2.4 2.2 2.4 3.8zm4.1-7l-.2.1c-.6.4-1.4.6-2.1.6-.8 0-1.6-.2-2.3-.7h-.1l-.2.1.2-.2c.7-.5 1.5-.7 2.4-.7.8 0 1.5.2 2.2.5.1 0 .2.1.3.2l-.2.1z"
          />
        </g>
      </svg>
    )
  }
}
